import React from 'react';
import { Table } from 'semantic-ui-react';
import DictionaryFieldNameTableCell from '../containers/DictionaryFieldNameTableCell';
import DictionaryFieldLabelTableCell from '../containers/DictionaryFieldLabelTableCell';
import DictionaryFieldTypeTableCell from '../containers/DictionaryFieldTypeTableCell';
import DictionaryFieldUriTableCell from '../containers/DictionaryFieldUriTableCell';
import DictionaryFieldPmnRuleTableCell from '../containers/DictionaryFieldPmnRuleTableCell';
import DictionaryFieldEntityTableCell from '../containers/DictionaryFieldEntityTableCell';
import DictionaryFieldDescriptionTableCell from '../containers/DictionaryFieldDescriptionTableCell';
import DictionaryFieldActionsCell from './DictionaryFieldActionsCell';
import DictionaryFieldCohortFilterTableCell from '../containers/DictionaryFieldCohortFilterTableCell';

const DictionaryFieldRow = ({
  code,
  category,
  dictionaryUUID,
  fieldUUID,
  fieldName,
  canEdit,
  upward,
  allowPmnTransfer,
  template,
}) => (
  <Table.Row>
    <DictionaryFieldNameTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
    />
    <DictionaryFieldLabelTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
    />
    <DictionaryFieldTypeTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
    />
    <DictionaryFieldDescriptionTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
    />
    <DictionaryFieldUriTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
    />
    {allowPmnTransfer && (
      <DictionaryFieldPmnRuleTableCell
        code={code}
        category={category}
        dictionaryUUID={dictionaryUUID}
        fieldUUID={fieldUUID}
      />
    )}
    <DictionaryFieldEntityTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
      fieldName={fieldName}
    />
    <DictionaryFieldCohortFilterTableCell
      code={code}
      category={category}
      dictionaryUUID={dictionaryUUID}
      fieldUUID={fieldUUID}
      fieldName={fieldName}
    />
    {canEdit && (
      <DictionaryFieldActionsCell
        code={code}
        category={category}
        dictionaryUUID={dictionaryUUID}
        fieldUUID={fieldUUID}
        upward={upward}
        template={template}
      />
    )}
  </Table.Row>
);

export default DictionaryFieldRow;
